import { useEffect, useState } from 'react'

import { useUpdatePassword } from '../../../../hooks/profile/useUpdatePassword'

import { Card } from '../../../card/Card'
import PasswordForm from './passwordForm/PasswordForm'

import { useApp } from '../../../../contexts/AppContext'
import { UpdateCredentials } from '../../../../types/user/auth'
import { BannerKind } from '../../../../types/contexts/AppContext'
import { UpdatePasswordFormData } from '../../../../types/user/userProfile'

const createPasswordFormData = (): UpdatePasswordFormData => ({
  currentPassword: {
    value: '',
    isValid: false,
  },
  newPassword: {
    value: '',
    isValid: false,
  },
})

const Password = () => {
  const { showBanner } = useApp()

  const [formData, setFormData] = useState<UpdatePasswordFormData>(
    createPasswordFormData()
  )

  const {
    updatePassword,
    loading,
    error,
    success,
    resetState: resetUpdatePasswordState,
  } = useUpdatePassword()

  useEffect(() => {
    if (success) {
      showBanner({
        kind: BannerKind.OK,
        msg: success,
      })

      resetForm()
    }

    if (error) {
      showBanner({
        kind: BannerKind.ERR,
        msg: error,
      })

      resetUpdatePasswordState()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, error])

  const handleChange = (
    name: string,
    value: string | boolean,
    isValid: boolean
  ) => {
    setFormData(prev => ({
      ...prev,
      [name]: {
        value,
        isValid,
      },
    }))
  }

  const isValid = Object.values(formData).every(input => input.isValid)

  const handleSubmit = async () => {
    if (!isValid) {
      return
    }

    const credentials: UpdateCredentials = {
      oldPassword: formData.currentPassword.value,
      newPassword: formData.newPassword.value,
    }

    await updatePassword(credentials)
  }

  const resetForm = () => {
    resetUpdatePasswordState()
    setFormData(createPasswordFormData())
  }

  return (
    <Card className="col-12 responsive-half-card">
      <PasswordForm
        formData={formData}
        loading={loading}
        onChange={handleChange}
        onSubmit={handleSubmit}
      />
    </Card>
  )
}

export default Password
